import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Auth from 'app/core/auth-shim';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticated  {
  constructor(private auth: AuthService, private router: Router) {
   }

   async canActivate(): Promise < boolean > {
    return new Promise((resolve) => {
      Auth.currentAuthenticatedUser({
          bypassCache: false
        })
        .then((user) => {
          if(user){
            resolve(true);
          }
        })
        .catch(() => {
          this.router.navigate(['/sign-in']);
          resolve(false);
        });
    });
  }
}

@Injectable({
  providedIn: 'root'
})
export class IsNotAuthenticated  {

  constructor(private auth: AuthService, private router: Router) {
    
   }

   async canActivate(): Promise < boolean > {
    return new Promise((resolve) => {
      Auth.currentAuthenticatedUser({
          bypassCache: false
        })
        .then((user) => {
          if(user){
            resolve(false);
            this.router.navigate(['/home/dashboard']);
          }
        })
        .catch(() => {
          resolve(true);
        });
    });
  }
}



